export const RECEIVE_INDEX_AREA = 'receive_index_area'
export const RECEIVE_AREA_CAT_ITEM = 'receive_area_cat_item'
export const RECEIVE_TOPIC_CAT_ITEM = 'receive_topic_cat_item'
export const RECEIVE_AREA_CAT_BOOK = 'receive_area_cat_book'
export const RECEIVE_TOPIC_CAT_BOOK = 'receive_topic_cat_book'
export const RECEIVE_ITEM_LIST = 'receive_item_list'
export const READING_TYPE = 'reading_type' // 1 条目 2 整书
export const RECEIVE_BOOK_ID = 'receive_book_id'
export const COUTER = 'COUTER'
export const RECEIVE_USER_INFO = 'receive_user_info'
export const SHOW_LOADING = 'show_loading'
export const HIDE_LOADING = 'hide_loading'
export const FILTER_CATEGORY = 'filter_category'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js